// The current application coordinates were pre-registered in a B2C tenant.
export default {
  b2cScopes: ["https://tribely.onmicrosoft.com/003db36e-616e-4a8f-a7e6-c23d13244ff6/Messages.Send"],
  webApi: "https://tribely.onmicrosoft.com/003db36e-616e-4a8f-a7e6-c23d13244ff6"
};